// Session-length options offered to a learner before they call a guide.
export const SESSION_DURATIONS = [15, 30, 45, 60] as const;
export const DEFAULT_DURATION_MINUTES = 30;

interface Props {
  value: number;
  onChange: (minutes: number) => void;
}

// A small segmented control (radiogroup) of session lengths. Presentational:
// the caller owns the selected value.
export function DurationSelector({ value, onChange }: Props) {
  return (
    <div role="radiogroup" aria-label="Session length" className="inline-flex flex-wrap gap-2">
      {SESSION_DURATIONS.map((m) => {
        const selected = m === value;
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(m)}
            className={
              'px-4 py-2 rounded-xl text-sm font-medium tabular-nums ring-1 transition ' +
              (selected
                ? 'bg-brand dark:bg-brand-bright text-ink-900 ring-brand dark:ring-brand-bright shadow-sm'
                : 'bg-surface-light dark:bg-surface-darkTint text-ink-700 dark:text-ink-200 ' +
                  'ring-ink-200/70 dark:ring-white/10 hover:ring-ink-300 dark:hover:ring-white/20')
            }
          >
            {m}m
          </button>
        );
      })}
    </div>
  );
}
